<template>
    <YpModal
        size="sm"
        :visible="isModalVisible"
        @closed="handleModalAction"
    >
        <div class="text-center">
            <img
                src="@/assets/img/png/rocket.png"
                alt="Nova atualização"
                class="w-32 h-auto mx-auto mb-8"
            />
            <h1 class="text-2xl font-medium mb-4">Atualize as informações dos apps direto do painel!</h1>
            <p class="text-gray-700">Agora você pode <b>editar as informações</b> e publicar <b>novas versões</b> para que as lojas tenham sempre o app atualizado.</p>
        </div>
        <template #footer>
            <div class="w-full flex gap-4">
                <YpButton
                    class="flex-1"
                    variant="secondary"
                    text="Fechar"
                    @click.prevent="handleModalAction()"
                />
                <YpButton
                    class="flex-1"
                    text="Saiba mais"
                    @click.prevent="handleModalAction(true)"
                />
            </div>
        </template>
    </YpModal>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import YpModal from '../core/YpModal.vue';
import YpButton from '../core/YpButton.vue';

const store = useStore();
const props = defineProps({
    visible: { type: Boolean, default: true },
});

const emit = defineEmits(['closed', 'success']);

// Closed modal actions
const isModalVisible = ref(props.visible);

const handleModalAction = (openLink = false) => {
    if (openLink) {
        window.open('https://help.yampi.com.br/pt-BR/articles/11758785-como-atualizar-meu-aplicativo-publicado-na-loja-de-apps-da-yampi', '_blank');
    }
    store.dispatch('featureModal/hideModal', 'developer');
    emit('closed');
};

watch(
    () => props.visible,
    (newVal) => {
        isModalVisible.value = newVal;
    },
);
</script>
